import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import Lodinging from "../components_root/loading.jsx";
import Lodingingimg from "../components_root/loadingimg.jsx";
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './edit_company.css';
import { Toast } from '../components_root/ToastContext';
import { VscDashboard } from "react-icons/vsc";
import { MdAdd, MdAddAPhoto, MdAnalytics, MdDashboard, MdFileOpen, MdFileUpload, MdHome, MdLocationCity, MdMenu, MdMonitor, MdOutlineAnalytics, MdSettings, MdSettingsAccessibility, MdTraffic, MdUpload } from "react-icons/md";
import { Uploader_companies_files } from "../components_root/uploader_companies_files.js";
import banner_default from '../assets/banner_default.jpg';
import logo_default from '../assets/logo_default.jpg';
import ShareButton from "../components_root/ShareButton.jsx";
import FollowButton from "../follow_root/follow_button.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

export default function Edit_company() {
    const location = useLocation();
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [company, setCompany] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading_banner, setIsLoading_banner] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [activeTab, setActiveTab] = useState("home");
    const [companyData, setCompanyData] = useState([]);
    const [uid, setUid] = useState("");
    const [old_file_uid, setOld_file_uid] = useState("");
    const [old_banner_file_uid, setOld_banner_file_uid] = useState("");
    const [logoUrl, setLogoUrl] = useState("");
    const [BannerUrl, setBannerUrl] = useState("");
 const [companyuid, setCompanyuid] = useState("");
    
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const uId = params.get("uid");
        if (uId) setUid(uId);

    }, [location]);
  const [guid, setGuid] = useState("");
      useEffect(() => {
        const sessionToken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");
        if (sessionToken && guid) {
          setGuid(guid);
        } else {
          setGuid(null);
        }
     
      }, []);

    useEffect(() => {
        const uId = Cookies.get("select_company_uid");

        if (uId && uId.trim() && uId.length === 12 && uId !== "undefined") {
            setUid(uId);
            setCompanyuid(uId);
        } else {
            navigate("/dashboard?menu=companieslist");
        }

    }, []);

    const fetchCompanies = async () => {
        setIsLoading(true);

        try {
            const q = query(
                collection(db, "companies"),
                where("uid", "==", Cookies.get("select_company_uid")),
           
            );

            const snapshot = await getDocs(q);

            if (snapshot.empty) {
                console.log("No companies found");
                setCompanyData([]);
                return;
            }
            const docs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();

                    // fetch child collection "fields"
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    let child = {};
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        child[fieldName] = fieldValue;
                    });

                    const fullData = { uid: docSnap.id, ...docData, child };

                    return fullData;
                })
            );
            setIsLoading_banner(false);
            setOld_file_uid(docs[0]?.logo_uid || "null"); // set old_file_uid state
            setBannerUrl(docs[0]?.banner_url || banner_default); // set BannerUrl state with a default placeholder if none
            setOld_banner_file_uid(docs[0]?.banner_uid || "null"); // set old_banner_file_uid state
            setLogoUrl(docs[0]?.logo_url || logo_default); // set logoUrl state with a default placeholder if none
            setCompanyData(docs); // update state
        } catch (err) {
            console.error("Error fetching companies:", err);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {

        fetchCompanies();
    }, []);
    //change banner
    const [banner_file, setBanner_file] = useState(null);  
    const banner_Upload = async () => {
        if (!banner_file) return;
        if (!old_banner_file_uid) return;
        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");

        // ⚡ Pass the uid of the company you’re editing
        const result = await Uploader_companies_files({
            file: banner_file,
            fileuid: Cookies.get("select_company_uid"),
            tablename: "companies",
            filename: "banner",
            old_file_uid: old_banner_file_uid,
        });

        if (result.success) { 
            Toastshow("Successfully!");
            setBanner_file(null);
           fetchCompanies();
        } else {
               setBanner_file(null);
            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (banner_file) {
           banner_Upload();
        }
    }, [banner_file]);
    //change logo
    const [logo_file, setLogo_file] = useState(null);  
    const logo_Upload = async () => {
        if (!logo_file) return;
        if (!old_file_uid) return;
        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!Cookies.get("select_company_uid")) return Toastshow("Please select company");

        // ⚡ Pass the uid of the company you’re editing
        const result = await Uploader_companies_files({
            file: logo_file,
            fileuid: Cookies.get("select_company_uid"),
            tablename: "companies",
            filename: "logo",
            old_file_uid,
        });

        if (result.success) { 
            Toastshow("Successfully!");
            setLogo_file(null);
            fetchCompanies();
        } else {
            
                setLogo_file(null);
            Toastshow(`Error: ${result.error}`);
        }
    };
    useEffect(() => {
        if (logo_file) {
            logo_Upload();
        }
    }, [logo_file]);
    return (
        <div className="container_size">
            {isLoading ? (
                <Lodinging />
            ) : companyData.length === 0 ? (
                <div className="text-h1 text-off center p-1">
                    No company data found.
                </div>
            ) : (
                <div className="edit_company_body">
                    <div className="banner-div">
                        {isLoading_banner === true ? (
                            <Lodinging />
                        ) : (
                            <>
                                <img
                                    src={BannerUrl || banner_default}
                                    onLoad={() => setIsLoading_banner(false)}
                                    alt="banner"
                                    className="banner_url"
                                />
                                <div className="change_image flex center">
                                    {banner_file !== null ? (
                                        <Lodingingimg />
                                    ) : (
                                        <label>
                                            <MdAddAPhoto  className="icon white cursor" />
                                            <input
                                                type="file" accept=".jpg,.jpeg,.png"
                                         
                                                style={{ display: "none" }}
                                                onChange={async (e) => {
                                                    const selectedFile = e.target.files[0];
                                                    if (selectedFile) {
                                                        setBanner_file(selectedFile);
                                                        setBannerUrl(URL.createObjectURL(selectedFile));

                                                    }
                                                }}
                                            />
                                        </label>

                                    )}

                                </div>
                            </>
                        )}
                    </div>
                    <div className="comp-div " >
                        <table>
                            <tr>
                                <td width={100}>
                                    <div className="logo-div">
                                        {isLoading_banner === true ? (
                                            <Lodinging />
                                        ) : (
                                            <>
                                                <img src={logoUrl}
                                                    alt="logo" className="logo_url" />


                                                <div className="change_image flex center">
                                                    {logo_file !== null ? (
                                                        <Lodingingimg />
                                                    ) : (
                                                        <label>
                                                            <MdAddAPhoto className="icon white cursor" />
                                                            <input
                                                             type="file" accept=".jpg,.jpeg,.png"
                                                                style={{ display: "none" }}
                                                                onChange={async (e) => {
                                                                    const selectedFile = e.target.files[0];
                                                                    if (selectedFile) {
                                                                        setLogo_file(selectedFile);
                                                                        setLogoUrl(URL.createObjectURL(selectedFile));

                                                                    }
                                                                }}
                                                            />
                                                        </label>

                                                    )}

                                                </div>
                                            </>
                                        )}

                                    </div>
                                </td>
                                <td>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td ><input type="text" maxLength={130} className="fcap p-1 text-h1 bold " value={companyData[0].company} /></td>
                                                <td width={70}><div className="button-ui2 fcap text-h2 p-22 bold"><MdAdd className="icon" /> Save</div></td>
                                                
                                                </tr>
                                                
                                        
  <tr>
                                        <td> <div className="button-ui0 fcap text-h3 p-22"> <FollowButton companyuid={companyuid} /></div></td>
                                        <td  > <ShareButton title={companyData[0].company} text={companyData[0].company} url={"https://aooz.in/" + companyData[0].slug} /> </td>
                                    </tr>
                                        </tbody>
                                    </table>

                                </td>
                            </tr>
                        </table>

                    </div>
                    <div className="p-2">

                        {companyData.map((row) => (
                            <div className="ui-items items-back " key={row.uid}>
                                <table  >
                                    <tbody>
                                        <tr>
                                            <td width={150} style={{ verticalAlign: "top" }} ><input type="text" maxLength={30} placeholder="New field name" className="fcap p-2 text-h2 bold"  /></td>
                                              <td ><textarea type="text" maxLength={500} rows={1} className="fcap p-2 text-h3 bold" value={old_file_uid} placeholder="Field value"  /></td>
                                                   <td style={{ verticalAlign: "top" }} width={70}><div className="button-ui2 fcap text-h2 p-22 bold"><MdAdd className="icon" /> Save</div></td>
                                            </tr>
                                    </tbody>
                                </table>

                            </div>
                        ))}
                    </div>
                </div>
            )}

        </div>
    );
}
